export const SuperSetButton = ({
  editDayMode,
  isLast,
  isSuperset,
  handleSuperset,
  exercise,
  exercises,
  keyId,
}) =>
  editDayMode && !isLast ? (
    <button
      data-button-type="text"
      className="superset-button"
      onClick={(e) => {
        e.stopPropagation();
        handleSuperset(isSuperset ? "remove" : "add", {
          fullExercise: exercise,
          nextExerciseId: exercises[keyId + 1]._id,
        });
      }}
    >
      <img
        src={
          isSuperset
            ? "/img/new-icons/superset-danger.svg"
            : "/img/new-icons/superset-gradient.svg"
        }
        height={16}
        width={16}
      />
      {isSuperset ? (
        <span
          style={{
            background: "none",
            color: "var(--danger)",
          }}
        >
          Remove Superset
        </span>
      ) : (
        <span>Add Superset</span>
      )}
    </button>
  ) : null;
